import { render, staticRenderFns } from "./addStartup.vue?vue&type=template&id=77f8005f&scoped=true&"
import script from "./addStartup.vue?vue&type=script&lang=js&"
export * from "./addStartup.vue?vue&type=script&lang=js&"
import style0 from "./addStartup.vue?vue&type=style&index=0&id=77f8005f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f8005f",
  null
  
)

export default component.exports